<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-img thumbnail fluid src="https://picsum.photos/250/250/?image=58" alt="Image 2"></b-img>
      </b-col>
      <b-col cols="6" class="text-left">
        <div style="padding-top:30px">
          <h2>
            <b>{{ thirdPartyData != null ? thirdPartyData.comp_name_eng : "" }}</b>
          </h2>
          <b-link to="#">{{ thirdPartyData != null ? thirdPartyData.website : "" }}</b-link>
          <h5>{{ thirdPartyData != null ? thirdPartyData.country : "" }}</h5>
        </div>
      </b-col>
      <b-col cols="4">
        <b-row>
          <b-col cols="12">
            <highcharts :options="halfDonutChart" />
          </b-col>
         
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      select: null,
      
      halfDonutChart: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 200
        },
        title: {
          text: "Risk Meter",
          align: "center",
          verticalAlign: "middle",
          y: 60
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              distance: -50,
              style: {
                fontWeight: "bold",
                color: "white"
              }
            },
            startAngle: -90,
            endAngle: 90,
            center: ["50%", "75%"],
            size: "110%"
          }
        },
        series: [
          {
            type: "pie",
            name: "Browser share",
            innerSize: "50%",
            data: [
              ["", 100],

              {
                name: "Other",
                y: 7.61,
                dataLabels: {
                  enabled: false
                }
              }
            ]
          }
        ]
      }
    };
  },
  props: {
    thirdPartyData: Object
  }
};
</script>